import { SITE_CORE_URL } from '@shared/constants/paths';

export const HEALTH_CONDITIONS = [
  {
    title: 'Acne',
    url: SITE_CORE_URL.healthConditionsAcne,
  },
  {
    title: 'Cough & Cold',
    url: SITE_CORE_URL.healthConditionsCoughAndCold,
  },
  {
    title: 'Cold Sores',
    url: SITE_CORE_URL.healthConditionsColdSores,
  },
  {
    title: 'Diarrhoea',
    url: SITE_CORE_URL.healthConditionsDiarrhoea,
  },
  {
    title: 'Constipation',
    url: SITE_CORE_URL.healthConditionsConstipation,
  },
  {
    title: 'Headache',
    url: SITE_CORE_URL.healthConditionsHeadache,
  },
  {
    title: 'Cardiovascular Diseases',
    url: SITE_CORE_URL.healthConditionsCardiovascularDisease,
  },
];

export const HIGHLIGHTS_AND_INSIGHTS_LINKS = [
  {
    title: 'Expert Voices',
    url: SITE_CORE_URL.highlightsAndInsightsExpertVoices,
  },
  {
    title: 'Health Safety Advisory',
    url: SITE_CORE_URL.highlightsAndInsightsHealthSafety,
  },
];

export const MEDICATIONS_DEVICES_AND_TREATMENTS_LINKS = [
  {
    title: 'Antifungal',
    url: SITE_CORE_URL.medicationsDevicesAntifungal,
  },
  {
    title: 'Benzhexol',
    url: SITE_CORE_URL.medicationsDevicesBenzhexol,
  },
  {
    title: 'Empagliflozin',
    url: SITE_CORE_URL.medicationsDevicesEmpagliflozin,
  },
  {
    title: 'Omeprazole',
    url: SITE_CORE_URL.medicationsDevicesOmeprazole,
  },
  {
    title: 'Benztropine',
    url: SITE_CORE_URL.medicationsDevicesBenztropine,
  },
  {
    title: 'Domperidone',
    url: SITE_CORE_URL.medicationsDevicesDomperidone,
  },
  {
    title: 'Influenza Vaccine',
    url: SITE_CORE_URL.medicationsDevicesInfluenzaVaccine,
  },
  {
    title: 'Pyridostigmine',
    url: SITE_CORE_URL.medicationsDevicesPyridostigmine,
  },
];

export const WELL_BEING_AND_LIFESTYLE_LINKS = [
  {
    title: 'Health Programmes',
    url: SITE_CORE_URL.wellBeingHealthProgrammes,
  },
  {
    title: 'Mental Wellness',
    url: SITE_CORE_URL.wellBeingMentalWellness,
  },
  {
    title: 'Active Ageing',
    url: SITE_CORE_URL.wellBeingActiveAgeing,
  },
  {
    title: 'Personal Care',
    url: SITE_CORE_URL.wellBeingPersonalCare,
  },
  {
    title: 'Caregiving',
    url: SITE_CORE_URL.wellBeingCaregiving,
  },
  {
    title: 'Pregnancy & Infant Health',
    url: SITE_CORE_URL.wellBeingPregnancyAndInfantHealth,
  },
  {
    title: `Child & Teen's Health`,
    url: SITE_CORE_URL.wellBeingChildAndTeensHealth,
  },
  {
    title: 'Sexual Health',
    url: SITE_CORE_URL.wellBeingSexualHealth,
  },
  {
    title: 'Exercise & Fitness',
    url: SITE_CORE_URL.wellBeingExerciseAndFitness,
  },
  {
    title: 'Substance Addiction',
    url: SITE_CORE_URL.wellBeingSubstanceAddiction,
  },
  {
    title: 'Food, Diet & Nutrition',
    url: SITE_CORE_URL.wellBeingFoodDietAndNutrition,
  },
  {
    title: 'Travel Health',
    url: SITE_CORE_URL.wellBeingTravelHealth,
  },
];

export const SUPPORT_AND_TOOLS_LINKS = [
  {
    title: 'Costs & Financing',
    url: SITE_CORE_URL.supportCostAndFinancing,
  },
  {
    title: 'Support & Care Programmes',
    url: SITE_CORE_URL.supportCareProgrammes,
  },
  {
    title: 'Statistics on Healthcare',
    url: SITE_CORE_URL.supportStatisticsHealthcare,
  },
  {
    title: 'Screening',
    url: SITE_CORE_URL.supportScreening,
  },
  {
    title: 'Tools & Resources',
    url: SITE_CORE_URL.supportToolsAndResources,
  },
];
